import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import css from './LowestPrice.module.scss';

interface Props {
  className?: string;
  lowestPrice: number;
}

const LowestPrice = (props: Props & InjectedIntlProps) => {
  return (
    <span className={classNames(css.LowestPrice, props.className)}>
      <span className={css.LowestPrice__Emphasis}>
        {props.intl.formatNumber(props.lowestPrice)}
      </span>
      {props.intl.formatMessage({ id: 'merchants.common.lowestPrice.unit' })}
    </span>
  );
};

export default injectIntl(LowestPrice);
